module.exports = __webpack_public_path__ + "img/app-explore-more@3x.b7ee8bb3.png";